export const PRODUCT_TYPE = {
    SIMPLE: 1,
    CLIP: 2
}

export enum FIELD_TYPE {
    STRING = 1,
    TEXT = 2,
    BOOLEAN = 3,
    DATETIME = 4,
    DATE = 5,
    TIME = 6,
    NUMBER = 7,
    CHOICE = 8
}
export enum COUPON_TYPE {
    ONE_TIME_PERCENTAGE = 1,
    REGULAR_PERCENTAGE = 2,
    ONE_TIME_FREE_CLIP = 3
}
